module.exports = "images/enfants_9.4fae22b9.png";